<template>
  <div class="PageBox" style="padding-bottom: 10px">
    <van-nav-bar fixed :border="false" :title="$t('task.show[0]')" left-arrow @click-left="$router.go(-1)" />
    
    <div class="ScrollBox">
      <div style="height:405px;background:#37774C;border-radius:0 0 20px 20px; text-align:center">
         <div style="height:30px;"></div>
        <img :src="infoData.link_info" style="height:160px;widht:160px;" />
        <h3 style="margin-top: 15px;">{{ infoData.title }}</h3>
        <div style="height:19px;"></div>
        <div style="width:337px;margin:0 auto;">
          <img :src="`./static/images/detail-bg.png`" style="width:337px;height:156px;">
           <div style="position:absolute;left: 50%;transform: translateX(-50%);top: 298px;">
            <div style="background: #FF792E;min-width: 220px;height: 24px;line-height: 24px;border-radius: 5px;">
              {{ $t("user.vipl") }}：{{ UserInfo.useridentity }}</div>
            <div style="font-size:42px;height:59px;line-height:59px;">{{ Number(UserInfo.today_earnings) }}{{ InitData.currency }}</div>
            <div>{{ $t("user.myEarnings.grid[2]") }}</div>
          </div>
       </div>

       <div class="mt15" style="width: 337px;margin: 0 auto;">
           <van-cell
            size="large"
            :title="$t('task.show[7]')"
            align="left"
            :value="infoData.code"
            v-if="UserInfo.vip_level>1"
          />

           <van-cell
            size="large"
            :title="$t('task.show[2]')"
            align="left"
            :value="infoData.status"
          />
           <van-cell
            size="large"
            :title="$t('task.show[3]')"
            align="left"
            :value="infoData.reward_price + InitData.currency"
          />
           <van-cell
            size="large"
            :title="$t('task.show[4]')"
            align="left"
            :value="infoData.add_time"
          />
           <van-cell
            size="large"
            :title="$t('task.show[5]')"
            align="left"
            :value="formatTime"
          />

          <!-- <van-button type="info" color="#37774C" block  class="mt15" disabled>{{$t('task.default[10]')}}</van-button> -->
         </div>

         
      </div>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      infoData: {},
      task_id: 0,
      formatTime:'',
      timer:0
    }
  },
  props: ['taskId'],
  created() {
    this.$Model.GetUserInfo();
    this.getTaskinfo()
  },
  mounted(){
      this.start();
  },
  methods: {
    countDownFun(time) {
      let startTime = new Date().getTime() / 1000; //当前时间
      time = parseInt(time - startTime);
      if(time<0) {
         return  '00:00:00'
      }
      let h = parseInt(time / (60 * 60) % 24);
      h = h < 10 ? "0" + h : h
      let m = parseInt(time / 60 % 60);
      m = m < 10 ? "0" + m : m
      let s = parseInt(time % 60);
      s = s < 10 ? "0" + s : s
      //console.log(time);
      if(h <= 0 && m <= 0 && s <= 0) {
        clearInterval(this.timer);
      }
      return  h + ':' + m + ':' + s + ' '
    },
    start(){

        this.timer =  setInterval(() => {
            this.formatTime = this.countDownFun(this.infoData.handle_time);
        }, 1000);
      
    },
    getTaskinfo() {
      this.$Model.GetTaskinfo(this.taskId, data => {
        if (data.code == 1) {
          this.infoData = data.info
        } else {
          this.$Dialog.Confirm(data.code_dec, () => {
            this.$router.push('/');
          })
        }
      })
    },

  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-nav-bar__title{color:#fff}
</style>